import { ReadonlyRepositoryListService } from '@softline/core';
import { SupplierPromotion } from '@softapps/wws/core';
import { computed, inject, Injectable } from '@angular/core';
import { routeParamAsNumber } from '@softline/application';
import { SupplierPromotionRepository } from '../repositories/supplier-promotion.repository';
import { SupplierPromotionQueryService } from './supplier-promotion-query.service';
import { SupplierPromotionQuery } from '../types/supplier-promotion.query';

@Injectable()
export class SupplierPromotionService extends ReadonlyRepositoryListService<
  SupplierPromotion,
  SupplierPromotion[],
  SupplierPromotionQuery
> {
  private readonly queryService = inject(SupplierPromotionQueryService);

  productId = routeParamAsNumber('id');
  override params = computed(() => {
    return {
      productId: this.productId() ?? 0,
      showAll: this.queryService.showAll(),
    };
  });

  constructor() {
    super(inject(SupplierPromotionRepository));
  }

  protected override getItems(
    result: SupplierPromotion[] | null | undefined
  ): SupplierPromotion[] {
    return result ?? [];
  }
}
